import { Automation } from "../../../features/work/pages/automation/Automation";
import { WorkDetailsView } from "../../../features/work/pages/details/WorkDetailsView";
import { WorkEmails } from "../../../features/work/pages/emails/WorkEmails";
import { WorkFilesTab } from "../../../features/files/WorkFilesTab";
import { WorkLog } from "../../../features/work/pages/workLog/WorkLog";
import { WorkNotes } from "../../../features/work/pages/notes/WorkNotes";
import { Reminders } from "../../../features/work/pages/reminders/Reminders";
import { WorkRepeats } from "../../../features/work/pages/repeats/WorkRepeats";
import { WorkSequences } from "../../../features/work/pages/sequences/WorkSequences";
import { WorkTime } from "../../../features/work/pages/time/WorkTime";
import { PagesEnum } from "./types";

export enum WorkPagesEnum {
  Details = "details",
  Time = "time",
  Notes = "notes",
  Repeats = "repeats",
  Emails = "emails",
  Sequences = "sequences",
  Files = "files",
  Automation = "automation",
  Reminders = "reminders",
  Log = "log",
}

export const WorkPages = {
  path: PagesEnum.Work,
  label: "Work",
  component: null,
  children: {
    details: {
      path: WorkPagesEnum.Details,
      label: "Summary",
      component: WorkDetailsView,
    },
    time: {
      path: WorkPagesEnum.Time,
      label: "Time",
      component: WorkTime,
    },
    notes: {
      path: WorkPagesEnum.Notes,
      label: "Notes",
      component: WorkNotes,
    },
    repeats: {
      path: WorkPagesEnum.Repeats,
      label: "Repeats",
      component: WorkRepeats,
    },
    files: {
      path: WorkPagesEnum.Files,
      label: "Files",
      component: WorkFilesTab,
    },
    emails: {
      path: WorkPagesEnum.Emails,
      label: "Emails",
      component: WorkEmails,
    },
    sequences: {
      path: WorkPagesEnum.Sequences,
      label: "Sequences",
      component: WorkSequences,
    },
    automation: {
      path: WorkPagesEnum.Automation,
      label: "Automation",
      component: Automation,
    },
    reminders: {
      path: WorkPagesEnum.Reminders,
      label: "Reminders",
      component: Reminders,
    },
    log: {
      path: WorkPagesEnum.Log,
      label: "Log",
      component: WorkLog,
    },
  },
};
